import Api from 'App/api'

export const getMaintenanceRequests = Api.get({
  controller: 'maintenance',
  action: 'list',
})

export const saveMaintenanceRequest = Api.postMultipart({
  controller: 'maintenance',
  action: 'save',
})

export const getMaintenanceRequestSettings = Api.get({
  controller: 'maintenance',
  action: 'getSettings',
})

export const getMaintenanceRequestsWithSettings = Api.get({
  controller: 'maintenance',
  action: 'listWithSettings',
})

export const getMaintenanceImageUrl = Api.get({
  controller: 'maintenance',
  action: 'viewImage',
})

export const submitMaintenanceFeedback = Api.post({
  controller: 'maintenance',
  action: 'sendFeedback',
})

export const getTranslatedText = Api.post({
  controller: 'maintenance',
  action: 'getTranslatedText',
})

export const getMaintenanceRequestsWithChatbot = Api.get({
  controller: 'communication',
  action: 'getCommsConfig',
})